module.exports = __webpack_public_path__ + "static/nginx-f58bc2a9b1245b29c29e0416c0b6b721.svg";